/**
 * @param {*} linkText 要复制的文本内容
 * @param {*} callback 复制成功的回调方法
 * 兼容问题
 * navigator.clipboard 在不安全情况（非https）下无法使用
 * document.execCommand('copy') 在safari一些版本无法正常使用
 */
function copyToClipboard(text: string) {
  return new Promise((resolve, reject) => {
    const isFallback = !navigator.clipboard;
    if (!isFallback) {
      navigator.clipboard
        .writeText(text)
        .then(
          () => {
            resolve(text);
          },
          () => {
            copy(text).then(resolve).catch(reject);
          },
        )
        .catch(() => {
          reject(text);
        });
    } else {
      copy(text).then(resolve).catch(reject);
    }
  });
}

function copy(text: string) {
  return new Promise<void>((resolve, reject) => {
    try {
      if (typeof document.execCommand === "function") {
        void 0;
        const isRTL = document.documentElement.getAttribute("dir") === "rtl";
        const fakeElement = document.createElement("textarea");
        // Prevent zooming on iOS
        fakeElement.style.fontSize = "12pt";
        // Reset box model
        fakeElement.style.border = "0";
        fakeElement.style.padding = "0";
        fakeElement.style.margin = "0";
        // Move element out of screen horizontally
        fakeElement.style.position = "absolute";
        fakeElement.style[isRTL ? "right" : "left"] = "-9999px";
        // Move element to the same position vertically
        let yPosition = window.pageYOffset || document.documentElement.scrollTop;
        fakeElement.style.top = `${yPosition}px`;

        fakeElement.setAttribute("readonly", "");
        fakeElement.value = text;
        // const inputField = document.createElement('input')
        // inputField.value = text
        document.body.appendChild(fakeElement);
        select(fakeElement);
        // inputField.select()
        let result = document.execCommand("copy");
        // inputField.remove()
        if (!result) {
          reject();
        } else {
          resolve();
        }
        fakeElement.remove();
      } else if ((window as any).clipboardData) {
        // 清除原有剪切板的数据
        (window as any).clipboardData
          .clearData()(
            // 将内容复制到剪切板
            window as any,
          )
          .clipboardData.setData("Text", text);
        resolve();
      }
      reject();
    } catch (err) {
      reject();
    }
  });
}

function select(element: any) {
  var selectedText;

  if (element.nodeName === "SELECT") {
    element.focus();

    selectedText = element.value;
  } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
    var isReadOnly = element.hasAttribute("readonly");

    if (!isReadOnly) {
      element.setAttribute("readonly", "");
    }

    element.select();
    element.setSelectionRange(0, element.value.length);

    if (!isReadOnly) {
      element.removeAttribute("readonly");
    }

    selectedText = element.value;
  } else {
    if (element.hasAttribute("contenteditable")) {
      element.focus();
    }

    var selection = window.getSelection();
    var range = document.createRange();

    range.selectNodeContents(element);
    selection && selection.removeAllRanges();
    selection && selection.addRange(range);

    selectedText = selection && selection.toString();
  }

  return selectedText;
}

export { copyToClipboard };
